import { lazy } from 'react';
export var TestPageAsync = lazy(function () { return import('./TestPage'); });
